(function () {
  angular
    .module("akitabox.ui.dialogs.workOrder.cancel")
    .controller(
      "CancelWorkOrderDialogController",
      CancelWorkOrderDialogController
    );

  /* @ngInject */
  function CancelWorkOrderDialogController(
    // Angular
    $q,
    // Material
    $mdDialog,
    // Services
    ToastService,
    WorkOrderService
  ) {
    var self = this;

    // Attributes
    self.saving = false;
    // have to set default false in order to run tests since workOrderIDs is passed in through locals
    self.multiple = self.workOrders ? self.workOrders.length > 1 : false;

    // Functions
    self.cancel = $mdDialog.cancel;
    self.confirm = confirm;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Cancel work orders
     */
    function confirm() {
      self.saving = true;
      self.determinateValue = 0;
      var increment = (1 / self.workOrders.length) * 100;
      var promiseArray = [];

      // Cancel the work orders
      for (var i = 0; i < self.workOrders.length; i++) {
        // The `building` structure in `workOrders[]` might be:
        // - a string value representing the building id;
        // - or an object including an `_id` property.
        const buildingId =
          self.workOrders[i].building._id || self.workOrders[i].building;
        promiseArray[i] = WorkOrderService.cancel(
          buildingId,
          self.workOrders[i]._id
        ).then(function (canceledWorkOrder) {
          self.determinateValue += increment;
          return canceledWorkOrder._id;
        });
      }

      $q.all(promiseArray)
        .then(function (canceledWorkOrderIDs) {
          $mdDialog.hide(canceledWorkOrderIDs);
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.saving = false;
        });
    }
  }
})();
